<div class="auth-page" [ngStyle]="loginBgStyle">
  <div class="auth-overlay"></div>

  <div class="auth-card">
    <img class="auth-logo" [src]="varGlobal.RUTA_IMAGEN_LOGO" alt="Logo" />
    <h1 class="auth-title">Iniciar sesión</h1>

    <!-- Loading overlay inside the card -->
    <div class="auth-loading-overlay" *ngIf="isSubmitting">
      <div class="auth-spinner"></div>
      <p class="auth-loading-text">Validando credenciales...</p>
      <button type="button" class="btn btn-outline-light btn-sm auth-cancel-btn" (click)="cancelarLogin()">
        <i class="fas fa-times me-1"></i>Cancelar
      </button>
    </div>

    <form name="loginForm" [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
      <label class="sr-only" for="rut">RUT</label>
      <input id="rut" type="text" class="form-control auth-input" placeholder="RUT" formControlName="RUT" autocomplete="username" [attr.disabled]="isSubmitting ? '' : null" />

      <label class="sr-only" for="password">Contraseña</label>
      <input id="password" type="password" class="form-control auth-input" placeholder="Contraseña" formControlName="PASSWORD" autocomplete="current-password" [attr.disabled]="isSubmitting ? '' : null" />

      <div *ngIf="errorMessage" class="auth-error alert alert-danger" role="alert">{{ errorMessage }}</div>

      <button type="submit" class="btn btn-primary auth-button" [disabled]="loginForm.invalid || isSubmitting">
        <span *ngIf="!isSubmitting">Iniciar</span>
        <span *ngIf="isSubmitting" class="d-flex align-items-center justify-content-center gap-2">
          <span class="spinner-border spinner-border-sm" role="status"></span>
          Ingresando...
        </span>
      </button>
    </form>
  </div>
</div>
